import {processUrlInCaseFailOverIsRequired} from "@/utils/urlUtils";

export default {

  isLocal: true,

  // HOST: 'ws://159.65.114.91:8100',
  // HOST: 'wss://staging-ws_backend.gamingcorpscasino.com/',
  HOST: processUrlInCaseFailOverIsRequired('wss://hohohodl-ws.gamingcorpscasino.com/'),
  fonts: ['Arial', 'Press Start 2P', 'Rubik', 'Tahoma', 'Rampart One'],
  locale: 'en',

  state: 'PRELOADER',

  sizes: {
    desktop: {
      total: {
        width: 880,
        height: 580
      },
      safe: {
        width: 880,
        height: 580
      }
    },
    preloader: {
      total: {
        width: 2450,
        height: 2300
      },
      safe: {
        width: 1350,
        height: 770
      }
    },
    mobileLandscape: {
      total: {
        width: 680,
        height: 604
      },
      safe: {
        width: 680,
        height: 604
      }
    }
  },

  TO_FIXED_VALUES: 2,
  MIN_COUNTUP_WIN: 2,
  MAX_CASHOUT_ON_SCREEN: 20,
  pattern:null,
  app:null,

  DefaultTimeForExplosion: 3,
  timeForExplosion: 0,


  realitiCheckPopup: {
    "status": 911,
    "message": "Reality Check",
    "title": "Reality Check",
    "buttons": [
      {
        "text": "Continue",
        "action": "continue"
      },
      {
        "text": "Quit",
        "action": "lobby"
      }
    ]
  },

  POPUP_KEYS: {
    SOMETHING_WENT_WRONG: 'SOMETHING_WENT_WRONG',
    SESSION_TIMEOUT: 'SESSION_TIMEOUT',
    REALITY_CHECK: 'REALITY_CHECK',
    CONNECTION_ERROR: 'CONNECTION_ERROR',
    CASINO_ERROR: 'CASINO_ERROR',
    INSUFFICIENT_FUNDS: 'INSUFFICIENT_FUNDS',
    BET_ERROR: 'BET_ERROR'
  },

  POPUP_TYPES: {
    SOMETHING_WENT_WRONG: 'SOMETHING WENT WRONG',
    SESSION_TIMEOUT: 'SESSION TIMEOUT',
    REALITY_CHECK: 'REALITY CHECK',
    CONNECTION_ERROR: 'CONNECTION ERROR',
    CASINO_ERROR: 'CASINO ERROR',
    INSUFFICIENT_FUNDS: 'INSUFFICIENT FUNDS',
    BET_ERROR: 'BET ERROR'
  }

}



